<button type="button" class="btn btn-icon btn-sm" (click)="download()" aria-label="download" title="Download CSV">
    <clr-icon shape="download"></clr-icon>
</button>
